import { Button, Container, Image, Spinner } from 'react-bootstrap';
import { FaArrowRight, FaEnvelope, FaFacebook, FaInstagram, FaPhone } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import About1 from '../../../assets/images/about-us.png';
import Dots from '../../../assets/images/dots.png';
import Pic from '../../../assets/images/Pic.png';
import Recipe from '../../../assets/images/recipe-impact.png';
import { CoreValuesGrid } from '../../../components/coreValues/CoreValuesGrid';
import { SFCLocation } from '../../../types/place.types';
import { getPartition } from '../../../utils/utils';
import '../FranchiseLayout.css';

interface FranchiseProps {
  location: SFCLocation | undefined;
}

export const AboutUsSubpage: React.FC<FranchiseProps> = ({ location }) => {
  const navigate = useNavigate();

  // SF-298 / SF-300: Prefer franchise_images for the carousel (per Katie and Erin's ask).
  // Fall back to location_images if no franchise images exist, then the static default.
  const carouselSource =
      (location?.franchise_images?.length ?? 0) > 0
          ? location!.franchise_images
          : location?.location_images ?? [];

  const isLocationLoaded = location !== undefined;

  const imgSlides: string[] = [];
  if (isLocationLoaded && carouselSource.length > 0) {
    const mappedImages = carouselSource.map((image: any) => {
      if (image.signed_url) return image.signed_url;
      if (!image.image_file_name) return About1;
      const url = `${image.s3_base_url ?? ''}/${getPartition(image.id)}/original/${image.image_file_name}`;
      return encodeURI(url);
    });
    imgSlides.push(...mappedImages);
  } else if (isLocationLoaded) {
    imgSlides.push(About1);
  }

  const hasMultipleSlides = imgSlides.length > 1;
  const carouselSettings = {
    dots: hasMultipleSlides,
    infinite: hasMultipleSlides,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: hasMultipleSlides,
    autoplaySpeed: 4000,
  };

  const capitalizeFirstLetter = (str: string): string => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
      <Container className="text-blue pb-5">
        <div className="col-12 d-flex about-us-container">
          <div className="col-md-5 col-sm-12 align-content-center welcome-text">
            <p className="text-weight-700 mt-3 mt-xl-5">Welcome to Sticky Fingers Cooking!</p>
            <h1 className="text-weight-700 text-blue my-3">{location?.title}</h1>
            <h3>
              Inspire your kids to love healthy foods & turn your picky eater into a food explorer.
            </h3>
            <div className="franchise-find-classes-btn">
              <Button
                  className="text-uppercase bg-orange mb-5 px-5 py-3"
                  onClick={() => window.scrollTo(0, 0)}
                  href={
  location?.latitude != null && location?.longitude != null
    ? `/sessions?origin=${location.latitude}_${location.longitude}`
    : '/sessions'
}              >
                Find Our Classes
                <FaArrowRight
                    className="ms-2"
                    size={22}
                />
              </Button>
            </div>

          </div>
          <div className="about-us-slider offset-min mt-3 mt-xl-5">
            <div className="carousel-container-about-us">
              {imgSlides.length > 0 ? (
                <Slider {...carouselSettings}>
                  {imgSlides.map((item, index) => (
                      <div
                          key={index}
                          className="carousel-item"
                      >
                        <Image
                            src={item}
                            onError={(e) => {
                              (e.target as HTMLImageElement).src = About1;
                            }}
                        ></Image>
                      </div>
                  ))}
                </Slider>
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center h-100"
                  role="status"
                >
                  <Spinner animation="border" variant="primary" />
                  <span className="visually-hidden">Loading carousel images</span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="w-100">
          <div className="d-flex justify-content-center my-5">
            <Image
                src={Dots}
                className="mw-100"
            ></Image>
          </div>
          <h3 className="text-align-center w-100 text-weight-700">Everywhere You Want Us to Be!</h3>
          <h5 className="text-weight-700 mt-5">
            Welcome to Sticky Fingers Cooking®, your home-grown kids' cooking school! We don't have a
            fixed location; we are everywhere you want us to be. Whether it's at your school, camp,
            community center or your child's birthday party, we bring the fun and education of cooking
            directly to you.
          </h5>
          <div className="w-100 d-flex justify-content-center mt-5">
            <Button
                className="button-header justify-content-center text-uppercase"
                onClick={() => navigate('/why-we-are-grate')}
            >
              Why we're Grate
            </Button>
          </div>
        </div>

        <div className="w-100">
          <div className="d-flex justify-content-center my-5">
            <Image
                src={Dots}
                className="mw-100"
            ></Image>
          </div>

          <h3 className="text-align-center w-100 text-weight-700">
            Who We Are
          </h3>

          <h5 className="text-weight-700" style={{ whiteSpace: 'pre-wrap' }}>{location?.location_information?.who_we_are}</h5>

          <div className="d-flex my-5 flex-nowrap align-items-center">
            <Image
                src={(location?.location_information as any)?.signed_contact_url ?? location?.location_information?.s3_image_url ?? Pic}
                className="pic-container"
            ></Image>
            <div className="contact-container">
              <h4 className="w-100 contact-text px-3">
                -{' '}
                <strong className="orange-text">
                  {capitalizeFirstLetter(location?.location_information?.franchise_owner_first_name ?? '')}{' '}
                  {capitalizeFirstLetter(location?.location_information?.franchise_owner_last_name ?? '')} &nbsp;·&nbsp; Franchise
                  Owner{' '}
                </strong>
              </h4>
              {location?.phone_number && (
                  <div className="d-flex align-items-center mb-2 px-3">
                    <FaPhone className="contact-icon" />
                    <p className="mb-0 ms-3">{location.phone_number}</p>
                  </div>
              )}
              {location?.location_information?.franchise_owner_email && (
                  <div className="d-flex align-items-center mb-2 px-3">
                    <FaEnvelope className="contact-icon" />
                    <p className="mb-0 ms-3">
                      {location.location_information.franchise_owner_email}
                    </p>
                  </div>
              )}
              <div className="d-flex align-items-center gap-3 px-3 mt-1">
                {location?.location_information?.facebook && (
                    <a
                        href={location.location_information.facebook}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Facebook"
                    >
                      <FaFacebook className="contact-icon contact-icon--social" />
                    </a>
                )}
                {location?.location_information?.instagram && (
                    <a
                        href={location.location_information.instagram}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Instagram"
                    >
                      <FaInstagram className="contact-icon contact-icon--social" />
                    </a>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="w-100">
          <div className="d-flex justify-content-center my-5">
            <Image
                src={Dots}
                className="mw-100"
            ></Image>
          </div>

          <h3 className="text-align-center w-100 text-weight-700 mb-5">Our Core Values + Mission</h3>
          <CoreValuesGrid />

          <div className="w-100 mt-5">
            <h5 className="text-weight-700 text-align-center">
              At Sticky Fingers Cooking®, we are mission focused on Cultivating 'Cool'inary Curiosity
              in Kids®—supporting lifelong skills in preparing, eating, and sharing nutritious foods.
              Because it's Thyme to Turnip the Beet on what kids eat®.
            </h5>
          </div>

          <div className="d-flex justify-content-center my-5">
            <Image
                src={Dots}
                className="mw-100"
            ></Image>
          </div>

          <div className="w-100 mt-5">
            <div className="d-flex justify-content-center recipe-image">
              <Image
                  src={Recipe}
                  className="recipe-image"
              ></Image>
            </div>
            <h3 className="text-weight-700 text-align-center mb-5">
              Our Recipe for Community Impact
            </h3>

            <h5 className="text-weight-700">
              Sticky Fingers Cooking® is dedicated to making a deliciously meaningful impact in our
              communities. With hundreds of thousands of students taught in thousands of schools and
              venues across the U.S., we're proud to enrich children's lives through our mobile
              cooking school model.
              <ul className="mt-3">
                <ol>
                  <strong>Community Outreach: </strong> We offer our programs to a wide range of
                  schools, libraries, camps, community centers, and more, spreading the joy of cooking
                  and healthy eating.
                </ol>
                <ol>
                  <strong>Giving Back: </strong> Giving back to our community is baked into our
                  company culture. We proudly reinvest in the communities we serve, enriching lives
                  and supporting local initiatives.
                </ol>
              </ul>
              If you're interested in bringing Sticky Fingers Cooking® to your school, camp, or
              organizing a fun birthday party, get in touch with us. We look forward to creating
              delightful culinary experiences and Cultivating 'COOL'INARY CURIOSITY in Kids® in our
              community. LETTUCE make a difference together!
            </h5>
          </div>
        </div>
      </Container>
  );
};